<template>
  <ContentWrapperControl
    no_bottom
    full_width
    class="min-h-screen bg-primary flex flex-col items-center overflow-y-auto p-4"
  >
    <div
      class="receipt-paper w-full max-w-md flex flex-col p-6 text-gray-800 shadow-lg"
    >
      <div class="flex justify-center mb-4">
        <img :src="getLogoPath()" class="w-24 h-24" />
      </div>

      <div class="text-center font-bold text-xl mt-4 mb-8">
        Summary of Votes
      </div>

      <div class="flex flex-col mb-4 border-b pb-4">
        <div class="mb-1">
          <span class="font-semibold">Ballot Number:</span>
          {{ voter.ballot_number || "" }}
        </div>
        <div class="mb-1">
          <span class="font-semibold">Name:</span> {{ voter.name || "" }}
        </div>
        <div class="mb-1">
          <span class="font-semibold">Account Number:</span>
          {{ voter.account_number || "" }}
        </div>
        <div class="mb-1">
          <span class="font-semibold">Serial Number:</span>
          {{ voter.serial_number || "" }}
        </div>
        <div class="mb-1">
          <span class="font-semibold">Number of Votes:</span> {{ voter.votes }}
        </div>
      </div>

      <div class="font-bold mt-4 mb-4">I. Board of Directors</div>
      <div v-for="category in boardCategories" :key="category.key" class="mb-2">
        <div class="underline font-semibold cursor-pointer mb-2">
          {{ category.label }} ({{ votes[category.key].length }})
        </div>
        <div class="mb-2">
          <template v-if="votes[category.key] && votes[category.key].length">
            <ol class="vote-list">
              <li v-for="c in votes[category.key]" :key="c.code">
                {{ c.name }}
              </li>
            </ol>
          </template>
          <template v-else>No votes selected.</template>
        </div>
      </div>

      <!-- Audit and Supervisory Committee -->
      <div class="font-bold mt-4 mb-4">II. Audit Committee</div>
      <div>
        <div class="mb-2">
          <template v-if="votes.audit && votes.audit.length">
            <ol class="vote-list">
              <li v-for="c in votes.audit" :key="c.code" class="mb-1">
                {{ c.name }}
              </li>
            </ol>
          </template>
          <template v-else>No votes selected.</template>
        </div>
      </div>

      <!-- Election Committee -->
      <div class="font-bold mt-4 mb-4">III. Election Committee</div>
      <div class="mb-2">
        <div class="underline font-semibold cursor-pointer mb-2">
          Civilian Category ({{ votes.election.length }})
        </div>
        <div class="mb-2">
          <template v-if="votes.election && votes.election.length">
            <ol class="vote-list">
              <li v-for="c in votes.election" :key="c.code" class="mb-1">
                {{ c.name }}
              </li>
            </ol>
          </template>
          <template v-else>No votes selected.</template>
        </div>
      </div>

      <div class="border-t mt-4 pt-4">
        <div class="mb-1">
          <span class="font-semibold">You Voted On:</span>
          {{ formatDate(voter.voted_on) }}
        </div>
        <div class="mb-1">
          <span class="font-semibold mb-1">You Submitted On:</span>
          {{ formatDate(voter.submitted_on) }}
        </div>
      </div>

      <div class="text-center text-xs mt-4 mb-6">
        THANK YOU FOR VOTING!<br /><em>Serving the AFP Since 1981</em>
      </div>

      <div class="flex justify-center">
        <ButtonControl theme="secondary" @click="submitVotes">
          {{ this.lang("lbl_0000015") }}
        </ButtonControl>
      </div>
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import GA from "@/services/GA";
import mixin from "@/mixin";

export default {
  mixins: [mixin],
  components: { ContentWrapperControl, ButtonControl },
  mounted() {
    this.$emit("checkauth", true);
    this.$emit("nofooter", true);

    console.log(this.$store.state.ga.selected_candidates);
  },
  data() {
    return {
      voter: {
        ballot_number: this.$store.state.ga.user.ballot_number,
        name:
          this.$store.state.info?.last_name +
          ", " +
          this.$store.state.info?.first_name +
          " " +
          this.$store.state.info?.middle_name,
        account_number: this.$store.state.info?.account_no,
        serial_number: this.$store.state.info?.serial_no,
        voted_on: this.formatDate(this.$store.state.ga.user.start_date),
        submitted_on: this.formatDate(new Date()),
        votes: this.$store.state.ga.user?.total_votes,
      },
    };
  },
  computed: {
    today() {
      const now = new Date();
      return now.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    votes() {
      const selected_bod = this.$store.state.ga.selected_candidates.bod || [];
      const bod_candidates = this.$store.state.ga.candidates.bod || [];
      const audit_candidates = this.$store.state.ga.candidates.audit || [];
      const elecom_candidates = this.$store.state.ga.candidates.elecom || [];

      const officer = bod_candidates.filter(
        (c) =>
          selected_bod.includes(c.code) &&
          c.type?.toLowerCase().includes("officer"),
      );
      const enlisted = bod_candidates.filter(
        (c) =>
          selected_bod.includes(c.code) &&
          c.type?.toLowerCase().includes("enlisted"),
      );
      const civilian = bod_candidates.filter(
        (c) =>
          selected_bod.includes(c.code) &&
          c.type?.toLowerCase().includes("civilian"),
      );
      const selected_audit = audit_candidates.filter((c) =>
        (this.$store.state.ga.selected_candidates.audit || []).includes(c.code),
      );
      const selected_election = elecom_candidates.filter((c) =>
        (this.$store.state.ga.selected_candidates.elecom || []).includes(
          c.code,
        ),
      );

      return {
        officer,
        enlisted,
        civilian,
        audit: selected_audit,
        election: selected_election,
      };
    },
    totalVotes() {
      return Object.values(this.votes).reduce(
        (sum, arr) => sum + arr.length,
        0,
      );
    },
    boardCategories() {
      return [
        { key: "officer", label: "Officer Category" },
        { key: "enlisted", label: "Enlisted Personnel Category" },
        { key: "civilian", label: "Civilian Category" },
      ];
    },
  },
  methods: {
    getLogoPath() {
      const path = "ga/";
      const file_name = "papsi_icon.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
    formatDate(date) {
      if (!date) return "01/01/1970 08:00:00";
      const d = new Date(date);
      return d.toLocaleDateString() + " " + d.toLocaleTimeString();
    },
    submitVotes() {
      this.$emit("showloader");

      const store = this.$store.state;
      const selected_candidates = store.ga.selected_candidates;
      const bod_candidates = store.ga.candidates.bod || [];
      const audit_candidates = store.ga.candidates.audit || [];
      const elecom_candidates = store.ga.candidates.elecom || [];

      const officer = bod_candidates.filter(
        (c) =>
          selected_candidates.bod?.includes(c.code) &&
          c.type?.toLowerCase().includes("officer"),
      );
      const enlisted = bod_candidates.filter(
        (c) =>
          selected_candidates.bod?.includes(c.code) &&
          c.type?.toLowerCase().includes("enlisted"),
      );
      const civilian = bod_candidates.filter(
        (c) =>
          selected_candidates.bod?.includes(c.code) &&
          c.type?.toLowerCase().includes("civilian"),
      );
      const audit = audit_candidates.filter((c) =>
        selected_candidates.audit?.includes(c.code),
      );
      const election = elecom_candidates.filter((c) =>
        selected_candidates.elecom?.includes(c.code),
      );

      const candidate_codes = [
        ...officer.map((c) => c.code),
        ...enlisted.map((c) => c.code),
        ...civilian.map((c) => c.code),
        ...audit.map((c) => c.code),
        ...election.map((c) => c.code),
      ];

      GA.vote(
        store.ga.code,
        store.ga.user.voter_key,
        store.ga.user.ballot_number,
        JSON.stringify(candidate_codes),
      )
        .then((response) => {
          store.ga.user.has_participated = true;
          store.ga.user.end_date = response.data.timestamp;
          // this.$router.push("/dashboard");
          this.$router.push("/ga/vote/rating");
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
  },
};
</script>

<style>
.receipt-paper {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
}

.vote-list {
  text-align: left;
  padding-left: 20px;
  margin: 0;
}
</style>
